export const FORM_ACTIONS_FOOTER_HEIGHT = 72;

// Updated at runtime by useTrackElementHeightVar, falls back to the constants above
export const HEADER_HEIGHT_CSS_VAR = '--digital-forms-header-height';
export const FOOTER_HEIGHT_CSS_VAR = '--digital-forms-footer-height';

export const CONTAINER_WIDTH = 650;
